
export default {
    name: 'taux-consultations',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {

    }
}